/* @refresh reload */
import { Route, Router } from "@solidjs/router";
import Login from "./pages/Login.jsx";
import Home from "./pages/Home.jsx";
import Interview from "./pages/Interview.jsx";
import Feedback from "./pages/Feedback.jsx";
import Signup from "./pages/Signup.jsx";
import TwoFactor from "./pages/TwoFactor.jsx";
import "./styles.css";

export default function Index() {
  return (
    <Router>
      <Route path="/" component={Login}></Route>
      <Route path="/home" component={Home}></Route>
      <Route path="/interview/:id" component={Interview}></Route>
      <Route path="/feedback/:id" component={Feedback}></Route>
      <Route path="/register" component={Signup}></Route>
      <Route path="/verify" component={TwoFactor}></Route>
      <Route
        path="*"
        component={() => <div style="color: white;">Page not found</div>}
      />
    </Router>
  );
}
